import {ApiCaller} from "../../utils/api";
import { URLS } from '../../utils/url'
import { Message } from 'element-ui'
import { InputNumberNotNegative } from "../../utils/validators";

const state = {
  newSubscription: {
    id: '',
    clinic: '',
    clinic_customer_note: '',
    purchase_date: '',
    member_code: '',
    subscription_package: {},
    total_point: undefined,
  },
  membershipSubscriptionRules: {
    clinic: [
      { required: true, message: '治療院を選択してください', trigger: 'blur' },
    ],
    clinic_customer_note: [
      { required: true, message: '名前を入力してください', trigger: 'blur' },
    ],
    member_code: [
      { required: true, message: '会員番号を入力してください', trigger: 'blur' },
      { validator: InputNumberNotNegative, message: '会員番号0以上の値にしてください', trigger: 'blur' }
    ],
    'subscription_package.id': [
      { required: true, message: '会員プランを入力してください', trigger: 'blur' },
    ],
    contract_status: [
      { required: true, message: '会員ステータスを入力してください', trigger: 'blur' },
    ],
    purchase_date: [
      { required: true, message: '購入日を入力してください', trigger: 'blur' },
    ],
    total_point: [
      { required: true, message: 'ポイント数を入力してください', trigger: 'blur' },
      { validator: InputNumberNotNegative, message: 'ポイント数は0以上の値にしてください', trigger: 'blur' }
    ]
  },
  isSubscriptionVisible: false,
  membershipSubscriptionIsEdit: false,
  membershipSubscriptions: [],
  editMembershipSubscription: {},
  queryMembershipSubscription: {
    member_identify: '',
    point_package_id: undefined,
    order: '',
    contract_status: '',
    clinic_id: undefined,
  },
  contractStatuses: [
    { key: 'in_effect', value: '契約中' },
    { key: 'pending', value: '休会中' },
    { key: 'discontinued', value: '退会中' },
  ],
}

const mutations = {
  SET_IS_SUBSCRIPTION_VISIBLE(state, payload) {
    state.isSubscriptionVisible = payload
  },

  SET_EDIT_MEMBERSHIP_SUBSCRIPTION(state, payload) {
    state.editMembershipSubscription = JSON.parse(JSON.stringify(payload))
  },

  SET_MEMBERSHIP_SUBSCRIPTION_IS_EDIT(state, payload) {
    state.membershipSubscriptionIsEdit = payload
  },

  SET_MEMBERSHIP_SUBSCRIPTIONS(state, payload) {
    state.membershipSubscriptions = payload
  },

  SET_QUERY_MEMBERSHIP_SUBSCRIPTION(state, payload) {
    state.queryMembershipSubscription = Object.assign(state.queryMembershipSubscription, payload)
  },
}

const actions = {
  async fetchMembershipSubscriptions({ state, commit, rootState }) {
    const response = await ApiCaller().get(URLS.MEMBERSHIP_SUBSCRIPTIONS(), {
      params: Object.assign({}, rootState.page, {
        member_identify: state.queryMembershipSubscription.member_identify,
        subscription_package_id: state.queryMembershipSubscription.point_package_id,
        order: state.queryMembershipSubscription.order,
        contract_status: state.queryMembershipSubscription.contract_status,
        clinic_id: state.queryMembershipSubscription.clinic_id,
      })
    })

    if (response) {
      commit('SET_MEMBERSHIP_SUBSCRIPTIONS', response.data.data)
      commit('page/SET_TOTAL', response.data.total, { root: true })
      commit('common/SET_START_WEEEKDAY', response.data.start_weekday, { root: true })
    }
  },
  async createMembershipSubscription({state, commit, dispatch}, payload) {
    const response = await ApiCaller().post(URLS.MEMBERSHIP_SUBSCRIPTIONS(), {
      membership_subscription_root: Object.assign({}, state.editMembershipSubscription, {
        clinic_customer_note_id: state.editMembershipSubscription.clinic_customer_note.id,
        point_package_id: state.editMembershipSubscription.subscription_package.id
      })
    })

    handleReceiveResponse(response, commit, dispatch)
  },
  async updateMembershipSubscription({state, commit, dispatch }, payload) {
    const response = await ApiCaller().put(URLS.MEMBERSHIP_SUBSCRIPTION(payload.id), {
      membership_subscription_root: Object.assign({}, state.editMembershipSubscription, {
        clinic_customer_note_id: state.editMembershipSubscription.clinic_customer_note.id,
        point_package_id: state.editMembershipSubscription.subscription_package.id
      })
    })

    handleReceiveResponse(response, commit, dispatch)
  },
  async removeMembershipSubscription({ state, dispatch, commit }, id) {
    const response = await ApiCaller().delete(URLS.MEMBERSHIP_SUBSCRIPTION(id))
    if (response.status === 200) {
      Message.success({
        message: response.data.message,
        type: 'success'
      })
      commit('SET_IS_SUBSCRIPTION_VISIBLE', false)
      dispatch('fetchMembershipSubscriptions')
    } else {
      Message.error({
        message: response.data.message
      })
    }
  }

}

function handleReceiveResponse(response, commit, dispatch) {
  if (!response) {
    return
  }

  if (response.status === 200) {
    Message.success({
      message: response.data.message,
      type: 'success'
    })
    commit('SET_IS_SUBSCRIPTION_VISIBLE', false)
    dispatch('fetchMembershipSubscriptions')
  } else {
    if (response.data.message !== '') {
      Message.error({message: response.data.message})
    }

    commit('error/SET_VALIDATION_ERRORS', response.data.errors, { root: true })
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
